/**
 * 補償表示情報
 */
export class CollateralShortNameInfo {
	// private 変数 ---------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
	private m_Label1				: string = null;	// 傷害死亡 / 死亡後遺障害
	private m_Label2				: string = null;	// 障害後後遺症害/入院
	private m_Label3				: string = null;	// 疫病死亡/通院
	private m_Label4				: string = null;	// 
	private m_Label5				: string = null;	// 治療救援費用/救援費用
	private m_Label6				: string = null;	// 
	private m_Label7				: string = null;	// 旅行中の事故による緊急費用/航空機欠航等宿泊費保険金
	// WRQ-4142_【旅行保険】阪急交通社 ホワイトラベル専用プラン追加 START
	private m_Label8				: string = null;	//  手術
	// WRQ-4142_【旅行保険】阪急交通社 ホワイトラベル専用プラン追加 END
	// ----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
	
	// プロパティ ------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
	/** 傷害死亡 / 死亡後遺障害 */
	public get label1(): string { return this.m_Label1; } public set label1(label1: string) { this.m_Label1 = label1; }
	/** 障害後後遺症害/入院 */
	public get label2(): string { return this.m_Label2; } public set label2(label2: string) { this.m_Label2 = label2; }
	/** 疫病死亡/通院 */
	public get label3(): string { return this.m_Label3; } public set label3(label3: string) { this.m_Label3 = label3; }
	/**  */
	public get label4(): string { return this.m_Label4; } public set label4(label4: string) { this.m_Label4 = label4; }
	/** 治療救援費用/救援費用 */
	public get label5(): string { return this.m_Label5; } public set label5(label5: string) { this.m_Label5 = label5; }
	/**  */
	public get label6(): string { return this.m_Label6; } public set label6(label6: string) { this.m_Label6 = label6; }
	/** 旅行中の事故による緊急費用/航空機欠航等宿泊費保険金 */
	public get label7(): string { return this.m_Label7; } public set label7(label7: string) { this.m_Label7 = label7; }
	// WRQ-4142_【旅行保険】阪急交通社 ホワイトラベル専用プラン追加 START
	/** 手術 */
	public get label8(): string { return this.m_Label8; } public set label8(label8: string) { this.m_Label8 = label8; }
	// WRQ-4142_【旅行保険】阪急交通社 ホワイトラベル専用プラン追加 END
	// -----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------

	// コンストラクタ ---------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
	constructor() { }
	// -----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
}
